var _path, _path2;
function _extends() { _extends = Object.assign ? Object.assign.bind() : function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }
import * as React from "react";
function SvgIconExport(_ref, svgRef) {
  let {
    title,
    titleId,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 16,
    height: 16,
    viewBox: "0 0 16 16",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _path || (_path = /*#__PURE__*/React.createElement("path", {
    d: "M13.666 6.79398H11.7393C10.1593 6.79398 8.87268 5.50732 8.87268 3.92732V2.00065C8.87268 1.63398 8.57268 1.33398 8.20602 1.33398H5.37935C3.32602 1.33398 1.66602 2.66732 1.66602 5.04732V10.954C1.66602 13.334 3.32602 14.6673 5.37935 14.6673H10.6193C12.6727 14.6673 14.3327 13.334 14.3327 10.954V7.46065C14.3327 7.09398 14.0327 6.79398 13.666 6.79398ZM8.18602 10.5207L6.85268 11.854C6.80602 11.9007 6.74602 11.9407 6.68602 11.9607C6.62602 11.9873 6.56602 12.0007 6.49935 12.0007C6.43268 12.0007 6.37268 11.9873 6.31268 11.9607C6.25935 11.9407 6.20602 11.9007 6.16602 11.8607C6.15935 11.854 6.15268 11.854 6.15268 11.8473L4.81935 10.514C4.62602 10.3207 4.62602 10.0007 4.81935 9.80732C5.01268 9.61399 5.33268 9.61399 5.52602 9.80732L5.99935 10.294V7.50065C5.99935 7.22732 6.22602 7.00065 6.49935 7.00065C6.77268 7.00065 6.99935 7.22732 6.99935 7.50065V10.294L7.47935 9.81398C7.67268 9.62065 7.99268 9.62065 8.18602 9.81398C8.37935 10.0073 8.37935 10.3273 8.18602 10.5207Z",
    fill: "white"
  })), _path2 || (_path2 = /*#__PURE__*/React.createElement("path", {
    d: "M11.6204 5.87365C12.2538 5.88032 13.1338 5.88032 13.8871 5.88032C14.2671 5.88032 14.4671 5.43365 14.2004 5.16699C13.2404 4.20032 11.5204 2.46032 10.5338 1.47365C10.2604 1.20032 9.78711 1.38699 9.78711 1.76699V4.09365C9.78711 5.06699 10.6138 5.87365 11.6204 5.87365Z",
    fill: "white"
  })));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgIconExport);
export default __webpack_public_path__ + "static/media/icon_export.b5275c59099ee8800d0b1d7debd3c574.svg";
export { ForwardRef as ReactComponent };